import React, { ReactElement, Fragment } from 'react'

import { ICase } from 'lib/entities/Case'

import CaseStateOpen from 'assets/images/case-status-open.png'
import CaseStateClosed from 'assets/images/case-status-closed.png'
import CaseStateWon from 'assets/images/case-status-won.png'

import useStyle from './style'

interface IProps {
	theCase: ICase
	className?: string
}

const stateMap = {
	pipedrive_won: CaseStateWon,
	client_approval: CaseStateOpen,
	contact_enrichment: CaseStateOpen,
	screenshot_review: CaseStateOpen,
	ready_for_export: CaseStateOpen,
	pipedrive_open: CaseStateOpen,
	pipedrive_lost: CaseStateClosed,
	rejected: CaseStateClosed,
	stage_01: CaseStateOpen,
	stage_02: CaseStateOpen,
	stage_03: CaseStateOpen,
	on_hold: CaseStateOpen,
}

export default function CaseState({
	theCase,
	className,
}: IProps): ReactElement | null {
	const classes = useStyle()

	if (!theCase.state) return null

	return (
		<Fragment>
			{ theCase.state === 'client_approval' ||
			 theCase.state === 'contact_enrichment' ||
			 theCase.state === 'ready_for_export' ||
			 theCase.state === 'pipedrive_open' ? (
				<div
					className={`${classes.root} ${className} ${classes.open}`}
					aria-label="case status open"
				></div>
			) : (
				<img
					alt={`case status ${stateMap[theCase.state]}`}
					width={24}
					src={stateMap[theCase.state]}
					className={`${classes.root} ${className}`}
				/>
			)}
		</Fragment>
	)
}
